import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import BetaNotice from "@/components/BetaNotice";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Pending from "@/pages/Pending";
import AlbumView from "@/pages/AlbumView";
import Post from "@/pages/Post";
import Search from "@/pages/Search";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Welcome from "@/pages/Welcome";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return <div className="min-h-[60vh] flex items-center justify-center text-[#8A8A8A]">Loading...</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace/>;
  return children;
}

function Shell() {
  return (
    <>
      <Navbar/>
      <main>
        <Routes>
          <Route path="/" element={<Landing/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/reset-password/:code" element={<ResetPassword/>}/>
          <Route path="/search" element={<Search/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/welcome/:from_screen_name" element={<Welcome/>}/>
          <Route path="/welcome" element={<Welcome/>}/>
          <Route path="/u/:screenName" element={<Profile/>}/>
          <Route path="/album/:id" element={<AlbumView/>}/>
          <Route path="/invite/:code" element={<Protected><Post/></Protected>}/>
          <Route path="/dashboard" element={<Protected><Dashboard/></Protected>}/>
          <Route path="/pending" element={<Protected><Pending/></Protected>}/>
          <Route path="/post" element={<Protected><Post/></Protected>}/>
          <Route path="/admin" element={<Protected><Admin/></Protected>}/>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </main>
      <Footer/>
      <Toaster richColors position="bottom-right"/>
      <BetaNotice/>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
